export default {
  isLogged: false,
  user: null,
  loginComandero: false,
};
